/**
 * Staff Users page
 *
 * Standalone page for staff account management (create/edit staff, roles, store
 * access). This is the Staff tab lifted out of the old combined User Management
 * page into the Admin Tools nav section.
 */
import { Box, Typography } from '@mui/material';
import { Badge as StaffIcon } from '@mui/icons-material';
import { StaffTab } from '../components/UserManagement/StaffTab';
import { useAdminTheme } from '../admin-theme';

const StaffUsers = () => {
  const { colors, glassHeaderStyle } = useAdminTheme();

  return (
    <Box sx={{ bgcolor: colors.bgDeepest, minHeight: '100vh' }}>
      <Box sx={{ ...glassHeaderStyle, px: 3, py: 2.5 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: colors.textPrimary,
            letterSpacing: '-0.02em',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <StaffIcon sx={{ fontSize: 32 }} />
          Staff Users
        </Typography>
        <Typography variant="body2" sx={{ color: colors.textSecondary, mt: 0.5 }}>
          Manage staff accounts, roles, and store access
        </Typography>
      </Box>

      <Box sx={{ p: 3 }}>
        <StaffTab />
      </Box>
    </Box>
  );
};

export default StaffUsers;
